<template lang="pug">
  v-dialog(
    v-model="computedShowModal"
    :max-width='maxWidth',
    :persistent='persistent',
  ).d-flex.justify-center.align-center
    v-card( :style='{ borderRadius: borderRadius, padding: buttonAreaPadding }').simple-modal
      PerfectScrollbar
        v-card-text
          slot(name='content')
      v-card-actions
        v-btn.elevation-0(
          v-if='showLButton'
          :text="lButtonAsText"
          @click='$emit("clickLButton")',
          :color='lButtonColor') {{ lButtonTitle }}
        v-spacer
        v-btn.elevation-0(
          v-if='showRButton'
          @click='$emit("clickRButton")',
          :color='rButtonColor',
          style="margin-l: 1rem;").white-text {{ rButtonTitle }}
</template>

<script>
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'

export default {
  components: {
    PerfectScrollbar
  },
  props: {
    lButtonMethod: {
      type: Function,
      default: () => {
      }
    },
    buttonAreaPadding: {
      type: String,
      default: () => '0px'
    },
    rButtonMethod: {
      type: Function,
      default: () => {
      }
    },
    lButtonTitle: {
      type: String,
      default: () => ''
    },
    rButtonTitle: {
      type: String,
      default: () => ''
    },
    borderRadius: {
      type: String,
      default: () => '4px'
    },
    showLButton: {
      type: Boolean,
      default: () => false
    },
    showRButton: {
      type: Boolean,
      default: () => false
    },
    lButtonAsText: {
      type: Boolean,
      default: () => false
    },
    lButtonColor: {
      type: String,
      default: () => 'white'
    },
    rButtonColor: {
      type: String,
      default: () => 'white'
    },
    persistent: {
      type: Boolean,
      default: () => false
    },
    maxWidth: {
      type: String,
      default: () => '700px'
    },
    showModal: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    computedShowModal: {
      get: function () {
        return this.showModal
      },
      set: function (nV) {
        this.$emit('update', nV)
      }
    }
  }
}

</script>

<style scoped>
.simple-modal {
  font-size: 1.125rem;
  line-height: 1.4em;
  font-weight: 300;
}
.white-text{
  color: white!important;
}
</style>
